export default "__VITE_ASSET__4aa968d2__"